import { Component, OnInit, Inject, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
//import { Observable } from 'rxjs';
//import { startWith, map } from 'rxjs/operators';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
//import { EditOpportunityDialog } from '../edit-opportunity/edit-opportunity.component';
//import { isChanged } from '@progress/kendo-angular-grid/dist/es2015/utils';
import { DatePipe } from '@angular/common';
import { ContactService } from '../../services/contact.service';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import {
    Contact,
    Employee,
    Opportunity,
    OpportunitySalesCycleMap,
    Product,
    QuoteOrderLine,
    QuoteOrderLineByOpportunity,
    QuoteOrderLineType,
    SalesCycle,
    SalesCycleCheckList,
    SalesCycleCheckListMap,
    SearchCustomerAction,
    SearchOpportunity
} from '../../models/models';

@Component({
    selector: 'sales-cycle-checklist',
    templateUrl: './sales-cycle-checklist.component.html',
    styleUrls: ['./sales-cycle-checklist.component.css'],
    standalone: false
})
export class EditSalesCycleCheckList implements OnInit, OnChanges, AfterViewInit {
    @Input() opportunityId: number = 0;
    @Input() opportunitySalesCycleMapId: number = 0;
    @Input() opportunitySalesCycleMap: OpportunitySalesCycleMap = {} as OpportunitySalesCycleMap;
    @Input() customerActionId: number = 0;

    private _opportunityId: number = 0;
    private savingSalesCycle: boolean = false;
    private editedLineRowIndex: number | undefined;
    private editedLine: QuoteOrderLine = {} as QuoteOrderLine;

    public opportunity: Opportunity = {} as Opportunity;
    public searchOpportunity: SearchOpportunity = {} as SearchOpportunity;
    public selectedOpp: OpportunitySalesCycleMap = {} as OpportunitySalesCycleMap;
    public salesCycles: SalesCycle[] = [];
    public salesCycleCheckLists: SalesCycleCheckList[] = [];
    public checkListMaps: SalesCycleCheckListMap[] = [];
    public customerActionList: SearchCustomerAction[] = [];
    public currentChecklist: SalesCycleCheckList[] = [];
    public employees: Employee[] = [];
    public products: Product[] = [];
    public contacts: Contact[] = [];
    public lines: QuoteOrderLineByOpportunity[] = [];
    public lineTypes: QuoteOrderLineType[] = [];
    public salesCycleGroup: UntypedFormGroup = new UntypedFormGroup({});
    public opportunityGroup: UntypedFormGroup = new UntypedFormGroup({});
    public actionView: GridDataResult = { data: [], total: 0 };
    public actionState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'eventDate' }] };
    public lineView: GridDataResult = { data: [], total: 0 };
    public lineState: State = { skip: 0, take: 10 };
    public newSalesCycleId: number = -1;
    public addNewContact: boolean = false;
    public contactName: string = '';
    public contactPhone: string = '';
    public contactEmail: string = '';
    public contactTitle: string = '';
    public contactSaveMessage: string = '';
    public phoneMask: string = "(999) 000-0000";
    public oppMessage: string = '';

    @ViewChild('stepper', { static: false }) stepper: MatStepper | undefined;

    constructor(private crmService: CRMService, private formBuilder: UntypedFormBuilder, private datePipe: DatePipe, private orderService: OrderService, private employeeService: EmployeeService,
    private contactService: ContactService) {
        this.opportunityGroup = formBuilder.group({
            customerCtrl: ['', Validators.required],
            ownerCtrl: [-1, Validators.required],
            opportunityName: ['', Validators.required],
            productCtrl: ['', Validators.required],
            closeDate: ['', Validators.required],
            salesCycleCtrl: ['', Validators.required],
            contactCtrl: [''],
            amountCtrl: ['', Validators.required]
        });
    }

    ngOnInit() {
        this.getSalesCycles();
        this.getSalesCycleCheckLists();
        this.getEmployees();
        this.getProducts();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.getOpportunity();

        if (changes.opportunitySalesCycleMap == null
            || changes.opportunitySalesCycleMap.currentValue == null
            || (changes.opportunitySalesCycleMap.currentValue as OpportunitySalesCycleMap).opportunityId == null) return;

        this.selectedOpp = changes.opportunitySalesCycleMap.currentValue as OpportunitySalesCycleMap;
    }

    ngAfterViewInit() {
        this.stepper!._steps.changes.subscribe(() => {
            var salesCycle = this.salesCycles.find(s => s.salesCycleId == this.selectedOpp.salesCycleId);

            if (!salesCycle) return;

            for (var i = 0; i < salesCycle.stage; i++) {
                this.stepper!.next();
            }

            if (salesCycle.stage == 0) {
                var sortDescriptor = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;

                if (sortDescriptor.sort) {
                    var ok = this.salesCycleGroup.controls;
                    this.currentChecklist = orderBy(this.salesCycleCheckLists.filter(s => s.salesCycle.stage == 0), sortDescriptor.sort);
                }
            }
        });

        this.stepper!.selectionChange.subscribe(indexChange => {
            if (this.salesCycleCheckLists.length < 1) return;

            var sortDescriptor = { skip: 0, take: 200, sort: [{ dir: 'asc', field: 'stage' }] } as State;

            if (sortDescriptor.sort) {
                var ok = this.salesCycleGroup.controls;
                this.currentChecklist = orderBy(this.salesCycleCheckLists.filter(s => s.salesCycle.stage == (indexChange.selectedIndex)), sortDescriptor.sort);
            }
        });
    }

    private loadData() {
        this.loadCheckListMaps();
        this.getActionsForOpportunity();
        this.getContacts();
        this.setOpportunityValues();
        this.getLineTypes();
        this.getLinesForOpportunity();
        this.alertUserForEstimatedRevenue();
    }

    private getOpportunity() {
        this.crmService.getOpportunityById(this.opportunityId).subscribe(result => {
            this.opportunity = result;
            this.loadData();
        });
        this.crmService.getSearchOpportunityByID(this.opportunityId).subscribe(result => {
            this.searchOpportunity = result.resultCollection[0];
        });
    }

    private getSalesCycles() {
        this.crmService.getSalesCycles().subscribe(result => {
            this.salesCycles = result;
            this.buildSalesCycleForm();
            this.setMapFormValues();
        });
    }

    private getSalesCycleCheckLists() {
        this.crmService.getSalesCycleCheckLists().subscribe(result => {
            this.salesCycleCheckLists = result;
            this.buildSalesCycleForm();
            this.setMapFormValues();
        });
    }

    private loadCheckListMaps() {
        this.crmService.getSalesCycleCheckListMapsByOpportunityId(this.selectedOpp.opportunityId).subscribe(result => {
            this.checkListMaps = result;
            this.setMapFormValues();
        });
    }

    private getActionsForOpportunity() {
        this.crmService.getSearchCustomerActionByOpportunityID(this.selectedOpp.opportunityId).subscribe(result => {
            this.customerActionList = result.resultCollection;
            this.setCustomerActionGrid();
        });
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    private getProducts() {
        this.orderService.getProducts().subscribe(result => {
            this.products = result;
        });
    }

    private getContacts() {
        if (this.opportunity.customerId == null) return;

        this.contactService.getContactsByTableIdType(this.opportunity.customerId, 'customer').subscribe(result => {
            this.contacts = result;
        });
    }

    public getLineTypes() {
        this.orderService.getQuoteOrderLineTypesByProductId(this.opportunity.productId).subscribe(result => {
            this.lineTypes = result;
        });
    }

    public getLinesForOpportunity() {
        this.orderService.getQuoteOrderLinesByOpportunityId(this.selectedOpp.opportunityId).subscribe(result => {
            this.lines = result;
            this.setLinesGrid();
        });
    }

    private buildSalesCycleForm() {
        if (this.salesCycles.length < 1 || this.salesCycleCheckLists.length < 1) return;

        for (let salesCycle of this.salesCycles) {
            var checkListGroup = new UntypedFormGroup({});
            var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

            for (let checkList of checkLists) {
                checkListGroup.addControl(checkList.stage.toString() + 'Checkbox', new UntypedFormControl('', Validators.required));
                checkListGroup.addControl(checkList.stage.toString() + 'Text', new UntypedFormControl(''));
            }

            this.salesCycleGroup.addControl(salesCycle.abbrev, checkListGroup);
        }
    }

    public getCheckListBySalesCycleId(salesCycleId: number): SalesCycleCheckList[] {
        return this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycleId);
    }

    setMapFormValues() {
        if (this.checkListMaps.length < 1 || this.salesCycles.length < 1 || this.salesCycleCheckLists.length < 1) return;

        for (let salesCycle of this.salesCycles) {
            var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;
            var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

            for (let checkList of checkLists) {
                var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);

                if (listMap != null) {
                    var checkBoxCtrl = salesGroup.controls[checkList.stage.toString() + 'Checkbox'];
                    var textCtrl = salesGroup.controls[checkList.stage.toString() + 'Text'];

                    checkBoxCtrl.setValue(listMap.completed);
                    textCtrl.setValue(listMap.notes);
                }
            }
        }
    }

    private setOpportunityValues() {
        this.opportunityGroup.controls['ownerCtrl'].setValue(this.opportunity.ownerEmployeeId);
        this.opportunityGroup.controls['opportunityName'].setValue(this.opportunity.notes);
        this.opportunityGroup.controls['productCtrl'].setValue(this.opportunity.productId);
        this.opportunityGroup.controls['salesCycleCtrl'].setValue(this.selectedOpp.salesCycleId);
        this.opportunityGroup.controls['contactCtrl'].setValue(this.opportunity.contactId);
        this.opportunityGroup.controls['amountCtrl'].setValue(this.opportunity.estimatedRevenue);
        this.opportunityGroup.controls['closeDate'].setValue(new Date(this.opportunity.expectedCloseDate));
    }

    private setCustomerActionGrid() {
        if (this.actionState.sort) {
            this.customerActionList = orderBy(this.customerActionList, this.actionState.sort);
        }

        this.actionView = process(this.customerActionList, this.actionState);
    }

    public actionDataStateChange(state: DataStateChangeEvent) {
        this.actionState = state;
        this.setCustomerActionGrid();
    }

    private setLinesGrid() {
        if (this.lineState.sort) {
            this.lines = orderBy(this.lines, this.lineState.sort);
        }

        this.lineView = process(this.lines, this.lineState);
    }

    public lineDataStateChange(state: DataStateChangeEvent) {
        this.lineState = state;
        this.setLinesGrid();
    }

    public lineEditHandler({ sender, rowIndex, dataItem }) {
        this.lineCloseEditor(sender);

        this.editedLineRowIndex = rowIndex;
        this.editedLine = Object.assign({}, dataItem);

        sender.editRow(rowIndex);
    }

    public lineCancelHandler({ sender, rowIndex }) {
        this.lineCloseEditor(sender, rowIndex);
    }

    private lineCloseEditor(grid, rowIndex = this.editedLineRowIndex) {
        grid.closeRow(rowIndex);
        this.resetLine(this.editedLine);
        this.editedLineRowIndex = undefined;
        this.editedLine = {} as QuoteOrderLine;
    }

    private resetLine(line: QuoteOrderLine) {
        if (!line) return;

        const originalLine = this.lines.find(l => l.quoteNumber == line.quoteOrderLineID)!;
        Object.assign(originalLine, line);
    }

    public lineSaveHandler({ sender, rowIndex, dataItem, isNew }) {
        var thisLine: QuoteOrderLineByOpportunity = Object.assign({}, dataItem);

        var newLineType = this.lineTypes.find(t => t.quoteOrderLineTypeId == thisLine.quoteOrderLineTypeId);

        if (newLineType == null) return;

        var line: QuoteOrderLine = Object.assign({}, dataItem);
        line.quoteOrderLineTypeID = thisLine.quoteOrderLineTypeId;
        line.lastModifiedByEmployeeID = thisLine.quoteOrderLineTypeId;
        line.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);

        //line.quoteOrderLineType = newLineType;

        this.orderService.saveQuoteOrderLine(line).subscribe(result => {            
            var wonSalesCycle = this.salesCycles.find(s => s.description == 'Won');
            var lostSalesCycle = this.salesCycles.find(s => s.description == 'Lost');

            if (wonSalesCycle != null && newLineType!.wonInd != null && newLineType!.wonInd == true && this.selectedOpp.salesCycleId != wonSalesCycle.salesCycleId) {
                this.newSalesCycleId = wonSalesCycle.salesCycleId;
                this.updateSalesCycle();
            }

            if (lostSalesCycle != null && newLineType!.lostInd != null && newLineType!.lostInd == true) {
                var lineCount = this.lines.length;
                var lostLineCount = this.lines.filter(l => l.lineTypeLostInd == true).length;

                if (lineCount == lostLineCount && this.selectedOpp.salesCycleId != lostSalesCycle.salesCycleId) {
                    this.newSalesCycleId = lostSalesCycle.salesCycleId;
                    this.updateSalesCycle();
                }
            }
        });

        sender.closeRow(rowIndex);
        this.editedLineRowIndex = undefined;
        this.editedLine = {} as QuoteOrderLine;
    }

    public saveChecklistMap(checklist: SalesCycleCheckList) {
        if (checklist == null) return;

        var salesGroup = this.salesCycleGroup.controls[checklist.salesCycle.abbrev] as UntypedFormGroup;

        if (!salesGroup) return;

        var checkboxCtrl = salesGroup.controls[checklist.stage.toString() + 'Checkbox'];

        if (!checkboxCtrl) return;

        var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checklist.salesCycleCheckListId);
        var completed = salesGroup.controls[checklist.stage.toString() + 'Checkbox'].value as boolean;
        var notes = salesGroup.controls[checklist.stage.toString() + 'Text'].value.toString();

        if (!completed && notes.length < 1 && listMap != null) {
            this.crmService.deleteSalesCycleChecklistMap(listMap).subscribe(result => {
                this.loadCheckListMaps();
            });
        }

        if (!completed || notes.length < 1) return;

        if (listMap == null) {
            listMap = {
                salesCycleCheckListMapId: 0,
                salesCycleCheckListId: checklist.salesCycleCheckListId,
                salesCycleId: checklist.salesCycleId,
                opportunityId: this.selectedOpp.opportunityId,
                createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!)
            } as SalesCycleCheckListMap;
        } else {
            listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
        }

        if (listMap.notes == notes && listMap.completed == completed) return;

        listMap.completed = completed;
        listMap.notes = notes;

        this.crmService.saveSalesCycleCheckListMap(listMap).subscribe(result => {
            var checklist = this.checkListMaps.find(c => c.salesCycleCheckListMapId == result.salesCycleCheckListMapId);

            if (checklist == null) {
                this.checkListMaps.push(result);
            } else {
                checklist.createdByEmployeeId = result.createdByEmployeeId;
            }
        });
    }

    public saveCheckLists(salesCycle: SalesCycle) {
        var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;
        var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

        for (let checkList of checkLists) {
            var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);
            var completed = salesGroup.controls[checkList.stage.toString() + 'Checkbox'].value as boolean;
            var notes = salesGroup.controls[checkList.stage.toString() + 'Text'].value.toString();

            if (!completed || notes.length < 1) continue;

            if (listMap == null) {
                listMap = {
                    salesCycleCheckListMapId: 0,
                    salesCycleCheckListId: checkList.salesCycleCheckListId,
                    salesCycleId: salesCycle.salesCycleId,
                    opportunityId: this.selectedOpp.opportunityId,
                    createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!)
                } as SalesCycleCheckListMap;
            } else {
                listMap.lastModifiedByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
            }

            listMap.completed = completed;
            listMap.notes = notes;

            this.crmService.saveSalesCycleCheckListMap(listMap).subscribe(result => {
                var hmmm = result;
            });
        }
    }

    public updateSalesCycle() {
        if (this.newSalesCycleId < 1 || this.savingSalesCycle) return;

        var salesCycle = this.salesCycles.find(s => s.salesCycleId == this.newSalesCycleId);

        if (salesCycle == null || this.selectedOpp.salesCycle.stage >= salesCycle.stage) return;

        this.savingSalesCycle = true;
        this.selectedOpp.salesCycleId = this.newSalesCycleId;
        this.selectedOpp.employeeId = parseInt(localStorage.getItem('EmployeeId')!);

        this.crmService.jumpOpportunitySalesCycle(this.selectedOpp).subscribe(result => {
            this.savingSalesCycle = false;
            this.loadCheckListMaps();

            for (var i = this.stepper!.selectedIndex; i < salesCycle!.stage; i++) {
                this.stepper!.next();
            }
        });
    }

    public customerActionSaved() {
        this.getActionsForOpportunity();
    }

    public getCompletedChecklistTimestamp(checklist: SalesCycleCheckList) {
        var listMap = this.checkListMaps.find(c => c.salesCycleCheckListId == checklist.salesCycleCheckListId);

        if (listMap == null || listMap.salesCycleCheckListMapId < 1 || !listMap.completed) return '';

        var completedDate = new Date(listMap.completedDate);
        var employee = this.employees.find(e => e.employeeId == listMap!.createdByEmployeeId);

        return ' | Completed ' +
            + (completedDate.getMonth() + 1) + '/' + completedDate.getDate() + '/' + completedDate.getFullYear()
            + ' by ' + (employee == null ? '' : employee.fullName);
    }

    public isChecklistComplete(salesCycle: SalesCycle): boolean {
        var isCompleted = true;

        var salesGroup = this.salesCycleGroup.controls[salesCycle.abbrev] as UntypedFormGroup;

        if (!salesGroup) return false;

        var checkLists = this.salesCycleCheckLists.filter(s => s.salesCycleId == salesCycle.salesCycleId);

        for (let checkList of checkLists) {
            var listMap = this.checkListMaps.find(s => s.salesCycleCheckListId == checkList.salesCycleCheckListId);
            var completed = salesGroup.controls[checkList.stage.toString() + 'Checkbox'].value as boolean;
            var notes = salesGroup.controls[checkList.stage.toString() + 'Text'].value.toString();

            if (!completed || notes.length < 1) {
                isCompleted = false;
            }
        }

        return isCompleted;
    }

    public getActionNotes(customerAction: SearchCustomerAction) {
        var isFollowUp = customerAction.parentCustomerActionID > 0 && customerAction.actionTypeID < 0;

        if (isFollowUp) {
            if (customerAction.parentCustomerActionID == null) {
                return "";
            }
            else {
                return 'Follow Up to ' + customerAction.parentCustomerActionTypeDesc + ' (' + this.datePipe.transform(new Date(customerAction.parentEventDate), 'M/dd/yyyy') + '): ' + customerAction.parentCustomerActionNotes;
            }
        } else {
            return customerAction.customerActionNotes;
        }
    }

    public saveOpportunity() {
        this.oppMessage = 'Saving opportunity';

        var opp = {
            opportunityID: this.selectedOpp.opportunityId,
            customerId: this.opportunity.customerId,
            productId: this.opportunityGroup.controls['productCtrl'].value,
            ownerEmployeeId: this.opportunityGroup.controls['ownerCtrl'].value,
            estimatedRevenue: this.opportunityGroup.controls['amountCtrl'].value,
            contactId: this.opportunityGroup.controls['contactCtrl'].value,
            notes: this.opportunityGroup.controls['opportunityName'].value,
            expectedCloseDate: this.opportunityGroup.controls['closeDate'].value,
            createDate: new Date()
        } as Opportunity;

        //var oppCycle = {
        //    opportunitySalesCycleMapId: this.selectedOpp.opportunitySalesCycleMapId,
        //    opportunity: opp,
        //    opportunityId: this.selectedOpp.opportunityId,
        //    createdDate: new Date(),
        //    employeeId: parseInt(localStorage.getItem('EmployeeId')!),
        //    salesCycleId: this.opportunityGroup.controls['salesCycleCtrl'].value
        //} as OpportunitySalesCycleMap;

        this.crmService.saveOpportunity(opp).subscribe(result => {
            this.oppMessage = 'Saved opportunity';
        }, error => {
            this.oppMessage = 'Failed to save opportunity';
        });
    }

    private alertUserForEstimatedRevenue() {
        if (this.selectedOpp != null && this.opportunity != null && this.selectedOpp.salesCycle != null
            && (this.opportunity.estimatedRevenue == null || this.opportunity.estimatedRevenue < 1)
            && (this.selectedOpp.salesCycle.description == 'Won'
                || this.selectedOpp.salesCycle.description == 'Finalist(50-75% win)'
                || this.selectedOpp.salesCycle.description == 'Pre-Award (90%)')) {
            alert('Please enter an estimated revenue for the opportunity below.');
        }
    }
}


@Component({
    selector: 'sales-cycle-checklist-dialog',
    templateUrl: './checklist-dialog.component.html',
    standalone: false
})
export class SalesCycleCheckListDialog {
    constructor(public dialogRef: MatDialogRef<SalesCycleCheckListDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    cancel(): void {
        this.dialogRef.close();
    }
}
